import React from 'react';

import { Tooltip } from 'antd';

import type { DateIntervalFormat, Interval } from '/imports/ui/foundation/DateTime/format';
import { formatDateInterval, formatDateTime } from '/imports/ui/foundation/DateTime/format';
import { styled } from '/imports/ui/foundation/Theme';
import type { DateComponentProps } from './shared';

const StyledDateWrap = styled('span', () => ({
  fontSize: 'inherit',
  whiteSpace: 'nowrap',
  variants: {
    wrap: {
      true: {
        whiteSpace: 'normal',
      },
    },
  },
}));

export interface DateIntervalProps extends DateComponentProps, Interval {
  format: DateIntervalFormat;
}

export const DateInterval = ({
  format,
  allowWrap = false,
  hideInTests = false,
  ...interval
}: DateIntervalProps): React.JSX.Element => {
  const element = (
    <StyledDateWrap
      wrap={allowWrap}
      data-chromatic="ignore"
      data-hide-in-tests={hideInTests || undefined}
    >
      {formatDateInterval(format)(interval)}
    </StyledDateWrap>
  );
  if (format === 'distance')
    return <Tooltip title={formatDateTime('timestamp')(interval.end)}>{element}</Tooltip>;
  if (format === 'duration')
    return <Tooltip title={formatDateInterval('dateTime')(interval)}>{element}</Tooltip>;
  return element;
};
